import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles  } from '@mui/styles';
import Toolbar from '@mui/material/Toolbar';
import MobileStepper from '@mui/material/MobileStepper';
import { Button as ReactButton } from '@mui/material';
import {
  Save,
  DoneAll,
  FilterNone,
  ArrowBackIos,
  ArrowForwardIos,
  ControlPointDuplicate,
  Delete,
  Cancel
} from '@mui/icons-material';
import { scrolledMoreThan } from '../../utils/window';
import { isLockedOrder, isPushed } from '../../utils/adManagerHelpers';
import { WithTracking } from "../WithTracking";
const Button = WithTracking(ReactButton);

const styles = theme => ({
  root: {
    position: 'sticky',
    top: 0,
    zIndex: 100
  },
  grow: {
    flexGrow: 1
  },
  stepper: {
    flexGrow: 1,
    width: 500,
    maxWidth: 700,
    padding: 0,
    background: theme.palette.common.white
  },
  stepperButton: {
    width: 225
  },
  flex: {
    flex: 1
  },
  bar: {
    minHeight: 50,
    background: theme.palette.common.white,
    borderBottom: '1px solid #c8c8c8'
  },
  buttons: {
    display: 'inline-block'
  },
  controls: {
    float: 'right'
  },
  leftIcon: {
    marginRight: theme.spacing(1)
  },
  rightIcon: {
    marginLeft: theme.spacing(1)
  },
  extraMargin: {
    marginRight: 20
  }
});


class PlacementToolbar extends Component {

  state = {
    sticky: false

  };

  componentDidMount() {
    window.addEventListener('scroll', this.paint);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.paint);
  }

  paint = () => {
    const { sticky } = this.state;
    if (scrolledMoreThan(60) && !sticky) {
      this.setState({ sticky: true })
    }
    if (!scrolledMoreThan(60) && sticky) {
      this.setState({ sticky: false })
    }
  };

  render() {
    const {
      isNew,
      theme,
      onSave,
      onSaveAndNew,
      classes,
      onBack,
      onClone,
      onDelete,
      onCancel,
      onNext,
      onPrior,
      onDone,
      editList,
      order,
      placement,
      currentPlacement,
      onCopySettings,
      isReadOnly
    } = this.props;

    const { sticky } = this.state;
    const background = sticky ? theme.palette.primary.light : theme.palette.common.white;
    const cancelImplemented = true;
    const isLocked = order ? order.lock : true;

    return(
      <div className={classes.root}>
        <Toolbar
          className={classes.bar}
          style={{background}}
        >
          <div className={classes.grow}>
            <div className={classes.buttons}>
              <Button onClick={onBack} className={classes.extraMargin} color="primary" tracking={{ action: "Back"}}>
                <ArrowBackIos className={classes.leftIcon} />
                Back
              </Button>

              { !isReadOnly &&
              <Button onClick={onSave} color="primary" disabled={isLocked} tracking={{ action: "Save"}}>
                <Save className={classes.leftIcon} />
                Save
              </Button>}

              { !isReadOnly && isNew && onSaveAndNew && (
              <Button onClick={onSaveAndNew} color="primary" disabled={isLocked} tracking={{ action: "Save and New"}}>
                <Save className={classes.leftIcon} />
                Save and New
              </Button>)}

              { !isReadOnly && !isNew && onCopySettings && !isLockedOrder(order) && !placement.packageId && (
              <Button color="primary" onClick={onCopySettings} disabled={isLocked} tracking={{ action: "Copy Settings"}}>
                <ControlPointDuplicate className={classes.leftIcon} />
                  Copy Settings
              </Button>
              )}

              {!isReadOnly && !isNew && onClone && !isLockedOrder(order) && (!placement.packageId) && (
              <Button color="primary" onClick={onClone} disabled={isLocked} tracking={{ action: "Clone"}}>
                <FilterNone className={classes.leftIcon} />
                  Clone
              </Button>
              )}

              {!isReadOnly && !isNew && onDelete && !isPushed(placement) && !isLockedOrder(order) && (
              <Button color="secondary" onClick={onDelete} disabled={isLocked} tracking={{ action: "Delete"}}>
                <Delete className={classes.leftIcon} />
                  Delete
              </Button>
              )}

              {!isReadOnly && !isNew && cancelImplemented && isPushed(placement) && !isLockedOrder(order) && (
                <Button color="secondary" onClick={onCancel} tracking={{ action: "Cancel Placement"}}>
                  <Cancel className={classes.leftIcon} />
                  Cancel Placement
                </Button>
              )}
            </div>

            {!isReadOnly && !isNew && editList && editList.length !== 0 && (
            <div className={classes.controls}>
              <MobileStepper
                variant="progress"
                style={{background}}
                steps={editList.length + 1}
                position="static"
                activeStep={currentPlacement}
                className={classes.stepper}
                nextButton={
                    currentPlacement === editList.length - 1 ?
                    (
                      <Button
                        color="primary"
                        onClick={onDone}
                        className={classes.stepperButton}
                        disabled={isLocked}
                        tracking={{ action: "Save & Done"}}
                      >
                        Save & Done
                        <DoneAll className={classes.rightIcon} />
                      </Button>
                    ) : (
                      <Button
                        color="primary"
                        onClick={onNext}
                        className={classes.stepperButton}
                        disabled={isLocked}
                        tracking={{ action: "Save & Next"}}
                      >
                        Save & Next
                        <ArrowForwardIos className={classes.rightIcon} />
                      </Button>
                    )
                  }
                backButton={(
                  <Button
                    color="primary"
                    onClick={onPrior}
                    className={classes.stepperButton}
                    disabled={currentPlacement === 0 || isLocked}
                    tracking={{ action: "Save & Prior"}}
                  >
                    <ArrowBackIos className={classes.leftIcon} />
                      Save & Prior
                  </Button>
                )}
              />
            </div>
            )}
          </div>
        </Toolbar>
      </div>
    )
  }
}

PlacementToolbar.defaultProps = {
  onDelete: () => {},
  onCancel: () => {}
};

PlacementToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  isNew: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  onCancel: PropTypes.func
};

export default withStyles(styles, { withTheme: true })(PlacementToolbar);
